import { Chip } from "@mui/material";

// Matches the mobile app's category chip styling (Tailwind blue-100/blue-700)
// instead of MUI's default grey Chip — used on product/shop detail pages.
const CategoryChip = ({ label, onClick, ...props }) => (
  <Chip
    label={label}
    size="small"
    onClick={onClick}
    sx={{
      bgcolor: "#dbeafe",
      color: "#1d4ed8",
      fontWeight: 600,
      cursor: onClick ? "pointer" : "default",
      "&:hover": onClick ? { bgcolor: "#bfdbfe" } : undefined,
    }}
    {...props}
  />
);

export default CategoryChip;
